import {
  JOB_URL, JOB_DETAILS, JOB_SIGNOFF, LOCK_SIGN_URL,
  GET_SWMS_SIGN, USER_LICENCES, JOB_REPORT_URL,
  GET_JOB_REPORT, PHOTOS_DOCS_URL, JOB_DETAILS_URL,
  GET_JOB_MEMBERS, JOB_MEMBERS_LIST, SIGNOFF_SHEET_URL,
  SWMS_SIGN_DETAIL_URL, GET_PHOTOS_DOCS_FILE,
  EMAIL_JOB_REPORT_URL, JOB_ALLOCATED_USER_URL, GET_SWMS_HISTORY,
  JOB_SCHEDULE_SHIFT_URL, USER_LICIENCE_DETAILS_URL, JOB_DOCUMENT_URL, GET_JOB_REPORT_VERSION_HISTORY, SWMS_SIGN_DETAIL_HISTORY_URL, JOB_REPORT_HISTORY_URL, ADD_JOB_NOTES_URL, SEARCH_ORG_JOB_STAFF_URL,
  GET_CALENDAR_JOB_DETAILS,
  GET_JOB_HISTORY_URL,
  JOB_REPORT_ORDER_URL,
  JOB_REPORT_CREATE_HISTORY_URL,
  JOB_REPORT_DOCUMENT_UDATE_URL,
  JOB_CLEANING_REPORT_INFO_URL,
} from '../dataProvider/constant'
import { startSipnner, stopSipnner } from '../utils/spinner';
import axiosInstance, { scopeApiInstance, scopeAxiosInstance, scopeV3AxiosInstance } from '../dataProvider/axiosHelper'
import { Strings } from '../dataProvider/localize';

export const getPhotosDocsFileList = job_id => dispatch => {
  return getAllPhotosDocsFileAPI(dispatch, job_id)
}

const getAllPhotosDocsFileAPI = (dispatch, job_id) => {
  startSipnner(dispatch);
  return scopeAxiosInstance.get(PHOTOS_DOCS_URL + '?job_id=' + job_id)
    .then(res => {
      stopSipnner(dispatch);
      if (res.data.status) {
        dispatch({
          type: GET_PHOTOS_DOCS_FILE,
          payload: res.data.data.job_photo_docs
        })
        return Promise.resolve(res.data.data.org_users)
      }
    })
    .catch((error) => {
      stopSipnner(dispatch);
      return Promise.reject(error.response ?
        error.response.data.message
        : Strings.network_error)
    });
}

export const deletePhotosDocsFile = (formdata) => dispatch => {
  startSipnner(dispatch);
  return scopeAxiosInstance.delete(PHOTOS_DOCS_URL, { data: formdata })
    .then(res => {
      stopSipnner(dispatch);
      if (res.data.status) {
        getAllPhotosDocsFileAPI(dispatch, formdata.job_id);
        return Promise.resolve(res.data)
      }
    })
    .catch(error => {
      stopSipnner(dispatch)
      return Promise.reject(error.response ? error.response.data.message : Strings.network_error)
    });
}

export const saveJobReport = (formData, job_id) => dispatch => {
  // console.log("cleanreport", formData);
  // console.log("cleanreport job id", job_id);


  startSipnner(dispatch);
  return scopeApiInstance.post(JOB_REPORT_URL, formData)
    .then(res => {

      // console.log("'''' res add reports", res);

      stopSipnner(dispatch);
      getAllJobReportAPI(dispatch, job_id)
      if (res.data.status) {
        return Promise.resolve(res.data.message)
      }
    })
    .catch((error) => {
      // console.log(error);
      stopSipnner(dispatch);
      return Promise.reject(error.response ?
        error.response.data.message
        : Strings.network_error)
    });
}

export const getJobReport = (job_id, job_number) => dispatch => {
  return getAllJobReportAPI(dispatch, job_id, job_number)
}

const getAllJobReportAPI = (dispatch, job_id, job_number) => {
  startSipnner(dispatch);
  return scopeApiInstance.get(JOB_REPORT_URL + (job_id ? '?job_id=' + job_id : '?job_number=' + job_number))
    .then(res => {
      stopSipnner(dispatch);
      if (res.data.status) {
        dispatch({
          type: GET_JOB_REPORT,
          payload: res.data.data.job_cleaning_report,
          basePath: res.data.data.base_path,
          filePath: res.data.data.file_path,
          versionCount: res.data.data.total_versions,
          jobDocument: res.data.data.job_report_documents,
          resizedFilePath: res.data.data.resized_file_path,
          jobSignOffs: res.data.data.job_report_signed_offs,
        })
        return Promise.resolve(res.data.data)
      }
    })
    .catch((error) => {
      stopSipnner(dispatch);
      return Promise.reject(error.response ?
        error.response.data.message
        : Strings.network_error)
    });
}

export const updateJobReport = (formData, job_id) => dispatch => {
  // console.log("updatecleanreport", formData);
  // console.log("cleanreport job id", job_id);
  startSipnner(dispatch);
  return scopeApiInstance.put(JOB_REPORT_URL, formData)
    .then(async res => {
      stopSipnner(dispatch);
      await getAllJobReportAPI(dispatch, job_id)
      if (res.data.status) {
        return Promise.resolve(res.data.message ? res.data.message : "Job Report Update Successfull")
      }
    })
    .catch((error) => {
      stopSipnner(dispatch);
      return Promise.reject(error.response ?
        error.response.data.message
        : Strings.network_error)
    });
}

export const deleteReport = (formData) => () => {
  return scopeApiInstance.delete(JOB_REPORT_URL, { data: formData }).then(res => {
    if (res.data && res.data.message) {
      return Promise.resolve(res.data.message);
    } else {
      return Promise.reject()
    }
  }).catch((error) => {
    if (error) {
      return Promise.reject(error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error);
    } else {
      return Promise.reject(null);
    }
  })
}

///////////delete doc

export const deleteDocument = (formdata) => () => {
  return scopeApiInstance.delete(JOB_REPORT_DOCUMENT_UDATE_URL, { data: formdata }).then(res => {
    if (res.data && res.data.message) {
      return Promise.resolve(res.data.message);
    } else {
      return Promise.reject()
    }
  }).catch((error) => {
    if (error) {
      return Promise.reject(error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error);
    } else {
      return Promise.reject(null);
    }
  })
}

///update doc

export const updateJobDocument = (formData, job_id) => dispatch => {
  // console.log("updatecleandoc", formData);
  // console.log("docreport job id", job_id);
  startSipnner(dispatch);
  return scopeAxiosInstance.put(JOB_DOCUMENT_URL, formData, { params: { job_id: job_id } })
    .then(async res => {
      stopSipnner(dispatch);
      await getAllJobReportAPI(dispatch, job_id)
      if (res.data.status) {
        return Promise.resolve(res.data.message ? res.data.message : "Job Document Update Successfull")
      }
    })
    .catch((error) => {
      stopSipnner(dispatch);
      return Promise.reject(error.response ?
        error.response.data.message
        : Strings.network_error)
    });
}

export const updateJobCleaningReportInfo = (jobId, requestBody) => () => {
  const url = `${JOB_CLEANING_REPORT_INFO_URL}?job_id=${jobId}`;

  return scopeApiInstance
    .put(url, requestBody)
    .then((res) => {
      if (res.data && res.data.status) {
        return Promise.resolve({
          message: res.data.message,
          data: res.data.data,
        });
      }

      return Promise.reject(Strings.generic_error);
    })
    .catch((error) => {
      return Promise.reject(
        error && error.response && error.response.data && error.response.data.message
          ? error.response.data.message
          : Strings.network_error
      );
    });
}





export const sendEmailJobReport = formData => dispatch => {

  startSipnner(dispatch);
  return scopeAxiosInstance.post(EMAIL_JOB_REPORT_URL, formData)
    .then(res => {
      stopSipnner(dispatch);
      if (res.data.status) {
        return Promise.resolve(res)
      }
    })
    .catch(error => {
      stopSipnner(dispatch)
      return Promise.reject(error.response ? error.response.data.message : Strings.network_error)
    });
}

export const getJobDetails = job_number => dispatch => {
  return getUpdatedJobDetails(dispatch, job_number)
}

const getUpdatedJobDetails = (dispatch, job_id) => {
  startSipnner(dispatch);
  return scopeApiInstance.get(GET_CALENDAR_JOB_DETAILS, { params: { job_id: job_id } })
    .then(res => {
      stopSipnner(dispatch);
      if (res.data.status) {
        dispatch({
          type: JOB_DETAILS,
          payload: res.data.data.jobs[0]
        })
        return Promise.resolve(res.data.data);
      }
    })
    .catch((error) => {
      stopSipnner(dispatch);
      return Promise.reject(error.response ?
        error.response.data.message
        : Strings.network_error)
    });
}

//////////////////job sign offf////////////

export const signOffReportUpdate = (formData, job_number) => dispatch => {
  // console.log(formData);
  startSipnner(dispatch);
  return scopeAxiosInstance.put("/job-report-sign-off", formData,
    {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      }
    })
    .then(res => {
      // console.log(res);
      stopSipnner(dispatch);
      // getAllJobSignOff(dispatch, job_number);
      return Promise.resolve(res.data.message);

    })
    .catch((error) => {
      stopSipnner(dispatch);
      return Promise.reject(error.response ?
        error.response.data.message
        : Strings.network_error)
    });
}





//////////////get job details not in use/////////

export const getAllJobDetails = Data => dispatch => {
  startSipnner(dispatch);
  return scopeAxiosInstance.get("https://un68tbgmwi.execute-api.ap-southeast-2.amazonaws.com/dev/api/v1/job-swms?job_id=18&scope_doc_id=6")
    .then(res => {
      // console.log(res);
      stopSipnner(dispatch);
      if (res.data.status) {
        dispatch({
          type: JOB_DETAILS,
          payload: res.data.data
        })
        return Promise.resolve(res.data.data);
      }
    })
    .catch((error) => {
      stopSipnner(dispatch);
      return Promise.reject(error.response ?
        error.response.data.message
        : Strings.network_error)
    });
}

///////////////////

export const updateJob = (formData) => dispatch => {
  startSipnner(dispatch);
  return scopeAxiosInstance.put(JOB_URL, formData)
    .then(async res => {
      await getUpdatedJobDetails(dispatch, formData.job_number)
      stopSipnner(dispatch);
      if (res.data.status) {
        return Promise.resolve(res.data.message)
      }
    })
    .catch((error) => {
      stopSipnner(dispatch);
      return Promise.reject(error.response ?
        error.response.data.message
        : Strings.network_error)
    });
}
export const getSWMSSignDetails = job_number => dispatch => {
  return getAllgetSWMSSignDetails(dispatch, job_number)
}

const getAllgetSWMSSignDetails = (dispatch, job_number) => {
  startSipnner(dispatch);
  return scopeAxiosInstance.get(SWMS_SIGN_DETAIL_URL + '?job_number=' + job_number)
    .then(res => {
      stopSipnner(dispatch);
      if (res.data.status) {
        dispatch({
          type: GET_SWMS_SIGN,
          payload: res.data.data.job_swms_sign,
          total_versions: res.data.data.total_versions
        })
        return Promise.resolve(res.data.data.org_users)
      }
    })
    .catch((error) => {
      stopSipnner(dispatch);
      return Promise.reject(error.response ?
        error.response.data.message
        : Strings.network_error)
    });
}

export const addJobSWMSSign = (formData, job_number) => dispatch => {
  startSipnner(dispatch);
  return scopeAxiosInstance.post(SWMS_SIGN_DETAIL_URL, formData)
    .then(res => {
      stopSipnner(dispatch);
      if (res.data.status) {
        getAllgetSWMSSignDetails(dispatch, job_number)
        return Promise.resolve(true)
      }
    })
    .catch(error => {
      stopSipnner(dispatch)
      return Promise.reject(error.response ? error.response.data.message : Strings.network_error)
    });
}


export const lockSignatureProcess = (formData) => dispatch => {
  startSipnner(dispatch);
  return scopeAxiosInstance.put(LOCK_SIGN_URL, formData)
    .then(async res => {
      stopSipnner(dispatch);
      if (res.data.status) {
        await getAllgetSWMSSignDetails(dispatch, formData.job_number)
        return Promise.resolve(true)
      }
    })
    .catch(error => {
      stopSipnner(dispatch)
      return Promise.reject(error.response ? error.response.data.message : Strings.network_error)
    });
}

export const updateJobScheduleShift = (formData) => dispatch => {
  startSipnner(dispatch);
  return scopeAxiosInstance.put(JOB_SCHEDULE_SHIFT_URL, formData)
    .then(res => {
      stopSipnner(dispatch);
      getUpdatedJobDetails(dispatch, formData.job_number)
      if (res.data.status) {
        return Promise.resolve(res.data.message)
      }
    })
    .catch((error) => {
      stopSipnner(dispatch);
      return Promise.reject(error.response ?
        error.response.data.message
        : Strings.network_error)
    });
}

export const signoffUpdate = (formData, job_number) => dispatch => {
  startSipnner(dispatch);
  return scopeAxiosInstance.post("/job-sign-off", formData)
    .then(res => {
      stopSipnner(dispatch);
      getAllJobSignOff(dispatch, job_number);
      return Promise.resolve(res.data.message);

    })
    .catch((error) => {
      stopSipnner(dispatch);
      return Promise.reject(error.response ?
        error.response.data.message
        : Strings.network_error)
    });
}

export const getJobSignOff = job_number => dispatch => {
  return getAllJobSignOff(dispatch, job_number)
}

const getAllJobSignOff = (dispatch, job_number) => {
  startSipnner(dispatch);
  return scopeAxiosInstance.get(/* SIGNOFF_SHEET_URL + */ '/job-sign-off?job_id=' + job_number)
    .then(res => {
      stopSipnner(dispatch);
      if (res.data.status) {
        dispatch({
          type: JOB_SIGNOFF,
          payload: res.data.data
        })
        return Promise.resolve(res.data.data);
      }
    })
    .catch((error) => {
      stopSipnner(dispatch);
      return Promise.reject(error.response ?
        error.response.data.message
        : Strings.network_error)
    });
}

export const deleteJobScheduleShift = (shift_id, job_number) => dispatch => {
  startSipnner(dispatch);
  return scopeAxiosInstance.delete(JOB_SCHEDULE_SHIFT_URL + '?id=' + shift_id)
    .then(res => {
      stopSipnner(dispatch);
      getUpdatedJobDetails(dispatch, job_number)
      if (res.data.status) {
        return Promise.resolve(res.data.message)
      }
    })
    .catch((error) => {
      stopSipnner(dispatch);
      return Promise.reject(error.response ?
        error.response.data.message
        : Strings.network_error)
    });
}

export const getSingleUserLicences = user_name => dispatch => {
  startSipnner(dispatch);
  return axiosInstance.get(USER_LICIENCE_DETAILS_URL + '?license_user_name=' + user_name)
    .then(res => {
      stopSipnner(dispatch);
      if (res.data.status) {
        dispatch({
          type: USER_LICENCES,
          payload: res.data.data
        })
        return Promise.resolve(res.data.data);
      }
    })
    .catch((error) => {
      stopSipnner(dispatch);
      return Promise.reject(error.response ?
        error.response.data.message
        : Strings.network_error)
    });
}

export const signOffJobSheet = (formData, job_number) => dispatch => {
  startSipnner(dispatch);
  return scopeAxiosInstance.put(SIGNOFF_SHEET_URL, formData)
    .then(res => {
      stopSipnner(dispatch);
      getAllJobSignOff(dispatch, job_number);
      return Promise.resolve(res.data.message);

    })
    .catch((error) => {
      stopSipnner(dispatch);
      return Promise.reject(error.response ?
        error.response.data.message
        : Strings.network_error)
    });
}

export const updateUserSiteTime = (formData) => dispatch => {
  startSipnner(dispatch);
  return scopeAxiosInstance.put(JOB_ALLOCATED_USER_URL, formData)
    .then(res => {
      stopSipnner(dispatch);
      getUpdatedJobDetails(dispatch, formData.job_number)
      if (res.data.status) {
        return Promise.resolve(res.data.message)
      }
    })
    .catch((error) => {
      stopSipnner(dispatch);
      return Promise.reject(error.response ?
        error.response.data.message
        : Strings.network_error)
    });
}



export const getJobMembers = job_id => dispatch => {
  startSipnner(dispatch);
  return scopeAxiosInstance.get(JOB_MEMBERS_LIST + '?job_id=' + job_id)
    .then(res => {
      stopSipnner(dispatch);
      if (res.data.status) {
        dispatch({
          type: GET_JOB_MEMBERS,
          payload: res.data.data.staff_list
        })
        return Promise.resolve(res.data.data);
      }
    })
    .catch((error) => {
      stopSipnner(dispatch);
      return Promise.reject(error.response ?
        error.response.data.message
        : Strings.network_error)
    });
}

export const getJobReportVersionHistory = (job_id, job_number, version) => dispatch => {
  startSipnner(dispatch);
  const url = `${JOB_REPORT_HISTORY_URL}?job_id=${job_id}&job_number=${job_number}&version=${version}`
  return scopeAxiosInstance.get(url)
    .then(res => {
      stopSipnner(dispatch);
      if (res.data.status) {
        dispatch({
          type: GET_JOB_REPORT_VERSION_HISTORY,
          payload: res.data.data.job_cleaning_report,
          filePath: res.data.data.file_path,
          resizedFilePath: res.data.data.resized_file_path
        })
        return Promise.resolve(res.data.data)
      }
    })
    .catch((error) => {
      stopSipnner(dispatch);
      return Promise.reject(error.response ?
        error.response.data.message
        : Strings.network_error)
    });
}

export const getSWMSHistory = (job_number, version) => dispatch => {
  startSipnner(dispatch);
  return scopeAxiosInstance.get(SWMS_SIGN_DETAIL_HISTORY_URL + '?job_number=' + job_number + "&version=" + version)
    .then(res => {
      stopSipnner(dispatch);
      if (res.data.status) {
        dispatch({
          type: GET_SWMS_HISTORY,
          payload: res.data.data.job_swms_sign,
        })
        return Promise.resolve(res.data.data.org_users)
      }
    })
    .catch((error) => {
      stopSipnner(dispatch);
      return Promise.reject(error.response ?
        error.response.data.message
        : Strings.network_error)
    });
}

export const getStaffBySearchKey = (searchKey, shift_date, site_time, yard_time, finish_time, shift_id) => dispatch => {
  startSipnner(dispatch);
  return scopeAxiosInstance.get(`${SEARCH_ORG_JOB_STAFF_URL}?key=${searchKey}`, {
    headers: {
      'shift_date': shift_date,
      'site_time': site_time,
      'yard_time': yard_time,
      'finish_time': finish_time,
      'shift_id': shift_id ? shift_id : null
    }
  }).then(res => {
    stopSipnner(dispatch);
    if (res.data.status) {
      return Promise.resolve(res.data.data);
    }
  })
    .catch((error) => {
      stopSipnner(dispatch);
      return Promise.reject(error.response ?
        error.response.data.message
        : Strings.network_error)
    });
}

export const addJobNotes = (formData, job_number) => dispatch => {
  startSipnner(dispatch);

  return scopeAxiosInstance.post(ADD_JOB_NOTES_URL, formData)
    .then(res => {
      stopSipnner(dispatch);
      if (res.data.status) {
        getUpdatedJobDetails(dispatch, job_number);
        return Promise.resolve(res.data.message)
      }
    })
    .catch(error => {
      stopSipnner(dispatch)
      return Promise.reject(error.response ? error.response.data.message : Strings.network_error)
    });
}

export const getJobHistory = (params = {}, abortController) => () => {
  return scopeAxiosInstance.get(GET_JOB_HISTORY_URL, { params: { ...params }, ...abortController }).then((res) => {
    if (res && res.data && res.data.data) {
      return Promise.resolve(res.data.data);
    } else {
      return Promise.reject(Strings.generic_error);
    }
  }).catch(error => {
    if (error) {
      return Promise.reject(
        error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
      );
    } else {
      return Promise.reject(null);
    }
  })
}

export const addUpdateJobReport = (formData, isAdd = true) => () => {
  const method = isAdd ? scopeApiInstance.post : scopeApiInstance.put
  return method(JOB_REPORT_URL, formData).then(async (res) => {
    if (res.data && res.data.message) {
      return Promise.resolve(res.data.message);
    } else {
      return Promise.reject()
    }
  }).catch((error) => {
    if (error) {
      return Promise.reject(error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error);
    } else {
      return Promise.reject(null);
    }
  })
}

export const updateReportOrder = (formData) => () => {
  return scopeApiInstance.put(JOB_REPORT_ORDER_URL, formData).then(async (res) => {
    if (res.data && res.data.message) {
      return Promise.resolve(res.data.message);
    } else {
      return Promise.reject()
    }
  }).catch((error) => {
    if (error) {
      return Promise.reject(error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error);
    } else {
      return Promise.reject(null);
    }
  })
}

export const createReportHistory = (abortController = {}, params = {}, showLoading = false) => dispatch => {
  if (showLoading) {
    startSipnner(dispatch);
  }
  return scopeApiInstance.get(JOB_REPORT_CREATE_HISTORY_URL, { ...abortController, params: params }).then(res => {
    if (showLoading) {
      stopSipnner(dispatch);
    }
    if (res.data && res.data.data) {
      return Promise.resolve(res.data.data)
    } else {
      return Promise.reject()
    }
  }).catch(error => {
    if (showLoading) {
      stopSipnner(dispatch);
    }
    if (error) {
      return Promise.reject(error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error);
    } else {
      return Promise.reject(null);
    }
  })
}

export const addUpdateJobReportDocument = (formData, isAdd = true) => () => {
  const url = isAdd ? JOB_REPORT_URL : JOB_REPORT_DOCUMENT_UDATE_URL;
  const method = isAdd ? scopeApiInstance.post : scopeApiInstance.put
  return method(url, formData).then(async (res) => {
    if (res.data && res.data.message) {
      return Promise.resolve(res.data.message);
    } else {
      return Promise.reject()
    }
  }).catch((error) => {
    if (error) {
      return Promise.reject(error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error);
    } else {
      return Promise.reject(null);
    }
  })
}
